import {
  FETCH_PROCEDURELIST_REQUEST,
  FETCH_PROCEDURELIST_SUCCESS,
  FETCH_PROCEDURELIST_FAILURE,
} from "./procedureListTypes";
import api from "../../utils/Api";
import axios from 'axios';

export const fetchProcedureListRequest = () => {
  return {
    type: FETCH_PROCEDURELIST_REQUEST,
  };
};

export const fetchProcedureListSuccess = (procedureList) => {
  return {
    type: FETCH_PROCEDURELIST_SUCCESS,
    payload: procedureList,
  };
};

export const fetchProcedureListFailure = (error) => {
  return {
    type: FETCH_PROCEDURELIST_FAILURE,
    payload: error,
  };
};

const CancelToken = axios.CancelToken;
let cancelRequest;
export const fetchProcedureList = (searchKey, sortBy, page) => {
  //cancel previous request if multiple hits done.
  cancelRequest && cancelRequest();
  const headers = {
    Authorization:
      "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
  };
  return async (dispatch) => {
    dispatch(fetchProcedureListRequest);
    try {
      const response = await api.get(
        "procedure?search_key=" +
          searchKey +
          "&sort_by=" +
          sortBy +
          "&page=" +
          page,
        {
          headers: headers,
          cancelToken: new CancelToken(function executor(c) {
            cancelRequest = c;
        })
        }
      );
      const procedureList = response.data.data;
      dispatch(fetchProcedureListSuccess(procedureList));
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log('Error: ', error.message); // => prints: Api is being canceled
      } 
      console.log("Redux error - ", error.response);
      const errorMsg = error.message;
      dispatch(fetchProcedureListFailure(errorMsg));
    }
  };
};
